"use strict";

exports.__esModule = true;
exports.StripeChartTooltipDate = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Time = require("../../Time");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TOOLTIP_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
var secondsFormatter = function secondsFormatter(value, format, timezone) {
  return (0, _momentTimezone["default"])(value).tz(timezone).format(format ? format : TOOLTIP_DATETIME_FORMAT);
};
var StripeChartTooltipDate = exports.StripeChartTooltipDate = function StripeChartTooltipDate(props) {
  var time = _react["default"].useContext(_Time.TimeContext);
  var timeInMs = props.timeInMs,
    style = props.style,
    format = props.format;
  var timestamp = timeInMs ? secondsFormatter(timeInMs, format, time.timezone.name) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "StripeChartTooltipDate",
    style: style
  }, timestamp);
};